import { Field, FieldArray, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import LabelCustomSelect from 'src/components/LabelSelect/LabelCustomSelect';
import Button from 'src/components/button';
import SlideInModal from 'src/components/slideInModal';
import TextField from 'src/components/text-field';
import Toggler from 'src/components/toggleButton';
import useFetch from 'src/hooks/useFetch';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';
import items from '../../items';

interface IProps {
  handleModal: () => void;
  showModal: boolean;
  fetchData: () => void;
  setEditModifier: (val: boolean) => void;
  setEditModifierId: (val: string) => void;
  editModifier: boolean;
  editModifierData: any;
  editModifierId: string;
}

type floorsPostValue = {
  name: string;
  options: optionType;
};
type optionType = {
  id: any;
  name: string;
  price: number;
  isDefault: boolean;
};
// form validation
const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Modifier Name must a at least 3 character long')
    .required('Modifier Name is required'),
  options: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string()
          .min(3, 'Options name must be at least 3 character long')
          .required('Option Name is required'),
        price: Yup.number()
          .typeError('Price must be in number')
          .required('Price is required'),
      })
    )
    .min(1, 'At least one input should be filed'),
  isRequired: Yup.boolean(),
});

const AddModifiers: React.FC<IProps> = ({
  showModal,
  handleModal,
  fetchData,
  editModifier,
  editModifierId,
  setEditModifier,
  editModifierData,
}) => {
  // const { data: getSingleModifier } = useFetch(
  //   `/modifiers/${editModifierId}`,
  //   editModifierId ? false : true
  // );

  const { data: itemsData } = useFetch('/items');
  const filterItems = itemsData?.items
    ? itemsData?.items?.map((item: any) => {
        return {
          name: item?.name,
          id: item?.id,
        };
      })
    : [];

  const [requiredOption, setRequiredOption] = useState(0);
  useEffect(() => {
    setRequiredOption(editModifier ? editModifierData?.maxSelections : 0);
  }, []);
  const counter = (count: number, values: any) => {
    const checkMin = values?.some((option: any) => option?.isDefault === true);

    const minVal = checkMin ? 1 : 0;
    if (requiredOption + count <= minVal) {
      setRequiredOption(minVal);
    } else if (requiredOption + count >= values?.length) {
      setRequiredOption(values?.length);
    } else {
      setRequiredOption(requiredOption + count);
    }
  };

  const uncheckDefaults = (values: any, id: any) => {};
  const [errorMsgPost, setErrorMsgPost] = React.useState('');
  const intValues = {
    name: editModifier && editModifierData ? editModifierData?.name : '',
    options: [],
    items: [],
    maxSelections:
      editModifier && editModifierData ? editModifierData?.maxSelections : 0,
    attachToItems: true,
    isRequired:
      editModifier && editModifierData ? editModifierData?.isRequired : false,
  };

  if (editModifier && editModifierData?.options) {
    intValues.options = editModifierData.options.map((option: optionType) => ({
      id: option.id || '',
      name: option.name || '',
      price: option.price || 0,
      isDefault: option.isDefault || false,
    }));
  }

  if (editModifier && editModifierData?.items) {
    intValues.items = editModifierData.items.map((item: any) => item?.id);
  }
  const handleSubmit = async (val: any) => {
    const editPayload = {
      id: editModifierId || null,
      name: val?.name,
      isRequired: requiredOption ? true : false,
      requiredSelections: requiredOption,
      maxSelections: val.options.length,
      attachToItems: val?.attachToItems || false,
      items: val?.attachToItems ? val?.items : [],
      options: val.options.map((option: any, index: number) => ({
        id: option.id || null,
        name: option.name,
        price: option.price,
        isDefault: option.isDefault,
      })),
    };
    try {
      if (editModifier) {
        await Service.put('/modifiers/edit', editPayload);
      } else {
        await Service.post('/modifiers/create', editPayload);
      }
      handleModal();
      toastAlert(
        'success',
        `${val?.name} modifier successfully ${
          editModifier ? 'edited' : 'added'
        }`
      );
      fetchData();
      setErrorMsgPost('');
    } catch (err: any) {
      setErrorMsgPost(err?.response?.data?.message);
    }
  };

  return (
    <>
      {showModal && (
        <SlideInModal
          showModal={showModal}
          title={editModifier ? 'Edit Modifier' : 'Add Modifier'}
          onClick={handleModal}
          className="bg-pure-white z-[9999]"
        >
          <div className="mx-5 mt-4">
            {errorMsgPost && (
              <p className="text-warning text-center text-sm font-semibold capitalize">
                {errorMsgPost}
              </p>
            )}
            <Formik
              initialValues={intValues}
              validateOnMount
              validationSchema={FORM_VALIDATION}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, isValid, values, setFieldValue }) => (
                <Form className="mt-5">
                  <div className="">
                    <TextField
                      label="Modifier Name"
                      name="name"
                      placeholder="Enter Modifier Name"
                      defaultValue={
                        editModifier && editModifierData
                          ? editModifierData?.name
                          : ''
                      }
                    />

                    <FieldArray
                      name="options"
                      render={(arrayHelpers) => (
                        <div>
                          {values.options.map((friend: any, index: number) => (
                            <div
                              key={index}
                              className="relative border border-border-color-dark p-4 rounded mb-5"
                            >
                              <TextField
                                name={`options.${index}.name`}
                                label={`Options Name`}
                                placeholder="Enter options Name"
                                defaultValue={
                                  editModifier && editModifierData
                                    ? editModifierData?.name
                                    : ''
                                }
                              />
                              <TextField
                                name={`options.${index}.price`}
                                label={`Price`}
                                placeholder="Enter option price"
                                type="text"
                                defaultValue={
                                  editModifier && editModifierData
                                    ? editModifierData?.price
                                    : ''
                                }
                              />

                              {/* <Toggler checked={true} title={'Mark as Default'} setChecked={setChecked}/> */}
                              <div className="flex items-center justify-between">
                                <h4>Mark as Default</h4>
                                <label
                                  htmlFor={`options.${index}.isDefault`}
                                  className="toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative cursor-pointer"
                                >
                                  <div
                                    className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-650 ${
                                      friend?.isDefault
                                        ? 'transform translate-x-full bg-primary'
                                        : ''
                                    }`}
                                  ></div>
                                  <input
                                    type="checkbox"
                                    id={`options.${index}.isDefault`}
                                    name={`options.${index}.isDefault`}
                                    className="hidden"
                                    defaultChecked={
                                      editModifier && editModifierData
                                        ? editModifierData?.options?.[index]
                                            ?.isDefault
                                        : false
                                    }
                                    onChange={(e: any) => {
                                      Array.from({
                                        length: values?.options?.length,
                                      }).map((item, idx) => {
                                        setFieldValue(
                                          `options.${idx}.isDefault`,
                                          idx === index
                                            ? !friend?.isDefault
                                            : false
                                        );
                                        !friend?.isDefault &&
                                          requiredOption === 0 &&
                                          setRequiredOption(1);
                                      });
                                    }}
                                  />
                                </label>
                              </div>
                              <button
                                type="button"
                                hidden
                                onClick={() => arrayHelpers.remove(index)}
                                className={`${
                                  index < 1 ? 'hidden' : ''
                                } absolute top-2 right-2 h-6 w-6 flex items-center justify-center rounded-md bg-primary text-pure-white disabled:bg-opacity-0`}
                              >
                                <MdOutlineDeleteOutline />
                              </button>
                            </div>
                          ))}
                          <div className="flex items-center justify-center my-4 border-light-gray border-t-2 border-dashed pt-4">
                            <button
                              type="button"
                              className="flex border-2 border-primary rounded-lg p-2 gap-4 items-center justify-center w-full "
                              onClick={() =>
                                arrayHelpers.push({ name: '', price: '' })
                              }
                            >
                              <IoMdAddCircleOutline size={26} color="#4062FF" />{' '}
                              Add Option
                            </button>
                          </div>
                        </div>
                      )}
                    />

                    <div className="flex items-center justify-between">
                      <h4>Required Option</h4>
                      <div className="flex gap-2">
                        <span
                          onClick={() => counter(-1, values?.options)}
                          className="cursor-pointer text-pure-white w-8 h-8 p-2 bg-light-gray hover:bg-light-grey rounded flex justify-center items-center "
                        >
                          -
                        </span>
                        <input
                          style={{ MozAppearance: 'textfield' }}
                          className="bg-transparent w-8 h-8 p-2 rounded"
                          name="maxSelections"
                          type="text"
                          min={
                            values?.options?.some(
                              (option: any) => option?.isDefault === true
                            )
                              ? '1'
                              : '0'
                          }
                          max={values?.options?.length}
                          value={requiredOption}
                          onChange={(e: any) =>
                            setRequiredOption(e.target.value)
                          }
                        />
                        <span
                          onClick={() => counter(1, values?.options)}
                          className="cursor-pointer text-pure-white w-8 h-8 p-2 bg-light-gray  hover:bg-light-grey rounded flex justify-center items-center "
                        >
                          +
                        </span>
                      </div>
                    </div>
                    <div className="mt-5 flex flex-col gap-5">
                      <Toggler
                        checked={values?.attachToItems}
                        defaultChecked={true}
                        title={'Attach to items'}
                        setFieldValue={setFieldValue}
                        name={'attachToItems'}
                      />
                      {values?.attachToItems && (
                        <Field
                          name="items"
                          options={filterItems}
                          className={'mt-3 mb-5'}
                          component={LabelCustomSelect}
                          isMulti={true}
                          label="Items"
                          defaultValue={
                            editModifier && editModifierData?.items
                              ? editModifierData?.items.map(
                                  (item: any) =>
                                    item.id && {
                                      label: item.name,
                                      value: item.id,
                                    }
                                )
                              : []
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div className="flex items-center justify-end mt-10">
                    <Button
                      text={editModifier ? 'edit modifier' : 'add modifier'}
                      variant="primary"
                      isSubmitting={isSubmitting}
                      isValid={isValid}
                      type="submit"
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </SlideInModal>
      )}
    </>
  );
};

export default React.memo(AddModifiers);
